export interface ShapeInterface {
  border: {
    outline: {
      none: string
      thin: string
      medium: string
    }
    radius: {
      full: string
      big: string
      medium: string
      small: string
    }
  }
  shadow: {
    rule: {
      first: string
      second: string
    }
  }
  opacity: {
    big: string
    medium: string
    small: string
    disabled: string
  }
}

export const shape: ShapeInterface = {
  border: {
    outline: {
      none: '0px solid',
      thin: '1px solid',
      medium: '2px solid'
    },
    radius: {
      full: '50%',
      big: '20px',
      medium: '10px',
      small: '5px'
    }
  },
  shadow: {
    rule: {
      first: '0px 0px 6px rgba(0,0,0,0.10)',
      second: '0px 0px 5px rgba(224,10,23,0.15)'
    }
  },
  opacity: {
    big: '80%',
    medium: '50%',
    small: '20%',
    disabled: '0.4'
  }
}
